import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(path);
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-orange-500/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-3">
              <Link to="/">
                <img 
                  src="/assets/5462257d1b4750d8f5ba16bf9b111bc3.png" 
                  alt="Hash Adz Logo" 
                  className="w-16 h-16 object-contain cursor-pointer"
                />
              </Link>
            </div>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {['Home', 'About', 'Services', 'News', 'Articles', 'Careers', 'Contact'].map((item) => (
                <button 
                  key={item}
                  onClick={() => handleNavigation(item === 'Home' ? '/' : `/${item.toLowerCase()}`)}
                  className="text-white hover:text-orange-400 transition-colors duration-300 cursor-pointer"
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-orange-400 transition-colors duration-300 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-md">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {['Home', 'About', 'Services', 'News', 'Articles', 'Careers', 'Contact'].map((item) => (
              <button 
                key={item}
                onClick={() => handleNavigation(item === 'Home' ? '/' : `/${item.toLowerCase()}`)}
                className="block w-full text-left px-3 py-2 text-white hover:text-orange-400 transition-colors duration-300 cursor-pointer"
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}